var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.order
    ? _c(
        "div",
        {
          directives: [
            {
              name: "htmlclass",
              rawName: "v-htmlclass",
              value: { "overlay-open": _vm.value },
              expression: '{"overlay-open": value}',
            },
          ],
          staticClass: "overlay",
          on: { click: _vm.onClickOutside },
        },
        [
          _c("div", { staticClass: "overlay__window" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showPrepare && !_vm.showReady,
                    expression: "!showPrepare && !showReady",
                  },
                ],
                staticClass: "overlay__content",
              },
              [
                _c("button", {
                  staticClass: "overlay__close-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onCloseButton.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("Order Nr. "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.order.number) },
                  }),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "overlay__text" }, [
                  _vm._v(_vm._s(_vm.order.order_label)),
                ]),
                _vm._v(" "),
                _vm.order.pagernumber
                  ? _c(
                      "div",
                      { staticClass: "overlay__text overlay__text--small" },
                      [_vm._v("Pager: " + _vm._s(_vm.order.pagernumber))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.trackernumber
                  ? _c(
                      "div",
                      { staticClass: "overlay__text overlay__text--small" },
                      [_vm._v("Tracker: " + _vm._s(_vm.order.trackernumber))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onChangeStateClick("new")
                      },
                    },
                  },
                  [_vm._v("New Order")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--yellow",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onChangeStateClick("in_production")
                      },
                    },
                  },
                  [_vm._v("Preparation")]
                ),
                _vm._v(" "),
                _vm.hasFeature("FEATURE_PREPAREBOXES")
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn--yellow",
                        attrs: { href: "" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onPrepareBoxClick.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v("Preparation Box")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--green",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onReadyClick()
                      },
                    },
                  },
                  [_vm._v("Ready")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn btn--blue",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onChangeStateClick("done")
                      },
                    },
                  },
                  [_vm._v("Order picked-up")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showPrepare,
                    expression: "showPrepare",
                  },
                ],
                staticClass: "overlay__content",
              },
              [
                _c("button", {
                  staticClass: "overlay__close-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onCloseButton.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _c("h2", [_vm._v("Choose Box")]),
                _vm._v(" "),
                _c("h3", { staticClass: "overlay__text" }, [
                  _vm._v("Preparation"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control__grid control__grid--pick-up",
                    class: [`control__grid--cols-${_vm.boxColumns}`],
                  },
                  _vm._l(_vm.currentPrepare, function (item) {
                    return _c("OrderBox", {
                      key: item.box,
                      attrs: { order: item },
                      on: {
                        click: function ($event) {
                          return _vm.onSelectBox(item, "in_prep_")
                        },
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onPrepareCloseClick.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Zurück")]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showReady,
                    expression: "showReady",
                  },
                ],
                staticClass: "overlay__content",
              },
              [
                _c("button", {
                  staticClass: "overlay__close-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onCloseButton.apply(null, arguments)
                    },
                  },
                }),
                _vm._v(" "),
                _c("h2", [_vm._v("Choose Box")]),
                _vm._v(" "),
                _c("h3", { staticClass: "overlay__text" }, [_vm._v("Ready")]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "control__grid control__grid--pick-up",
                    class: [`control__grid--cols-${_vm.boxColumns}`],
                  },
                  _vm._l(_vm.currentPickups, function (item) {
                    return _c("OrderBox", {
                      key: item.box,
                      attrs: { order: item },
                      on: {
                        click: function ($event) {
                          return _vm.onSelectBox(item, "in_box_")
                        },
                      },
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onReadyCloseClick.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Zurück")]
                ),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }